import { type FaqSectionModel } from '@/models/faq-section.model';
import { ValidatorResult } from '@/models/validation-result.model';
import type { FaqModel } from '@onrunning/backstage-models';
import { CrudService } from './crud.service';

export class FaqsService {
  private crudService: CrudService<FaqModel>;

  constructor() {
    this.crudService = new CrudService<FaqModel>('faqs');
  }

  public async getFaqSections(): Promise<ValidatorResult<FaqSectionModel[]>> {
    return await this.crudService.do('get', 'sections', undefined, undefined, 'silent');
  }

  public async getFaqs(): Promise<ValidatorResult<FaqModel[]>> {
    return await this.crudService.do('get', '', undefined, undefined, 'silent');
  }
}
